import React from 'react';
import TooltipWarning from './TooltipWarning';
import tooltips from '../tooltips.json';

const checkIfBrokerDisbaled = (val = '', options = []) => {
  const { brokerDisabled = false } =
    options.find((op) => op && op.value && op.value === val) || {};

  return brokerDisabled;
};

function BrokerDisabledWarning({ options = [], value = '', className = '' }) {
  const disabled = checkIfBrokerDisbaled(value, options);

  return (
    <>
      {disabled ? (
        <TooltipWarning
          title={tooltips.brokerDisabled}
          className={`tooltip-box ${className}`}
          color="#eda80e"
        />
      ) : (
        ''
      )}
    </>
  );
}

export default BrokerDisabledWarning;
